module.exports = __webpack_public_path__ + "img/lounge.f257adf.svg";